var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor",class:{ fullWidth:_vm.fullWidth }},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editor",staticClass:"text"})])
}
var staticRenderFns = []

export { render, staticRenderFns }